// @ts-ignore
import mapboxgl from 'mapbox-gl';

export default function patch() {
  mapboxgl.workerClass =
    // eslint-disable-next-line import/no-webpack-loader-syntax
    require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
}
